import React from "react";

const Loader = () => (
  <div className="relative z-10">
    <div className="fixed inset-0 bg-gray-700 opacity-75 transition-opacity"></div>
    <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
      <div className="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
        <div
          style={{ borderTopColor: "transparent" }}
          className="w-16 h-16 border-4 rounded-full animate-spin"
        />
      </div>
    </div>
  </div>
);

export default Loader;



// WEBPACK FOOTER //
// ./app/javascript/bundles/ui/Loader/index.jsx